import { XMLJSON } from "../../livedataFuncs";
import { DropdownArrayObj } from "../fileToolbarConsts";

//Function to show Add new alert if depending on category
export function calculateNumberOfNotes(mainNoteItems: XMLJSON[], noteDropdownState: string, showOpenNotesOnly: boolean) {
    let arrayPosition = DropdownArrayObj.mainScreenNameIndex[noteDropdownState];
    let counter = 0;
    if(mainNoteItems !== undefined && mainNoteItems !== null){
        if (noteDropdownState === "All") {
            return mainNoteItems.length;
        }
        mainNoteItems.forEach(function (note) {
            if(note.attributes.mainScreenName === DropdownArrayObj.mainScreenNames[arrayPosition]) { 
                if(showOpenNotesOnly){
                    if(note.attributes.reactIsCheckMarked !== "1"){
                        counter++;
                    }
                }else{
                    counter++;
                }
            }
        });
    }
    return counter;
}